import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardSSO extends KeycloakAuthGuard implements CanActivate {
    constructor(protected readonly router: Router, protected readonly keycloakService: KeycloakService) {
        super(router, keycloakService);
    }

    async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        if (!this.authenticated) {
            // Si no está autenticado, redirige a Keycloak
            await this.keycloakService.login({
                redirectUri: window.location.origin + state.url,
            });
            return false;
        }

        // Si ya está autenticado, permite el acceso
        return true;
    }
}
